export class ToggleShow {
    public static readonly type = '[Toggle] Show';
}
export class ToggleHide {
    public static readonly type = '[Toggle] Hide';
}
